import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'nk-entity-match-decision-type-title',
  imports: [TranslateModule],
  templateUrl: './entity-match-decision-type-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityMatchDecisionTypeTitleComponent {
  public isCompany = input.required<boolean>();
  public severalMatches = input.required<boolean>();
}
